import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/motion";

export const LegalPage = ({ title, updated, intro, sections, testid }) => {
  const lenis = useLenis();
  return (
    <div className="App min-h-screen bg-white" data-testid={testid}>
      <Navbar />
      <main className="mx-auto max-w-3xl px-5 sm:px-8 pt-36 pb-28">
        <Reveal>
          <Link
            to="/"
            data-testid="legal-back-link"
            onClick={() => lenis && lenis.scrollTo(0)}
            className="inline-flex items-center gap-2 text-sm font-medium text-slatey hover:text-ink transition-colors duration-200"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="mt-10 text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">Legal</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tighter text-ink leading-[0.98]">{title}</h1>
          <p className="mt-4 text-sm text-slatey">Last updated: {updated}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 rounded-2xl border border-amber-200 bg-amber-50 p-4">
            <p className="text-sm text-amber-800">This is placeholder content for pre-launch. Final legal terms will be published before public launch.</p>
          </div>
          <p className="mt-8 text-lg leading-relaxed text-slatey">{intro}</p>
        </Reveal>

        <div className="mt-10 space-y-9">
          {sections.map((s, i) => (
            <Reveal key={i} delay={0.05 * i}>
              <h2 className="font-display text-xl font-bold tracking-tight text-ink">{i + 1}. {s.h}</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-slatey">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};
